import { render, staticRenderFns } from "./BusinessConsultingPage.vue?vue&type=template&id=669853ea&scoped=true"
import script from "./BusinessConsultingPage.vue?vue&type=script&lang=js"
export * from "./BusinessConsultingPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessConsultingPage.vue?vue&type=style&index=0&id=669853ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669853ea",
  null
  
)

export default component.exports